export const assetURLs = {
  'kosmodTransparentLogo': new URL('./transparent_logo.png', import.meta.url).href,
  'kosmodTransparentLogoWhite': new URL('./transparent_logo_white.png', import.meta.url).href,
  videos: {
    'devclip-voice-chat-1': new URL('./dc-vc-1.mp4', import.meta.url).href,
  },
  icons: {
    'house': new URL('./house.png', import.meta.url).href,
    'settingsCog': new URL('./settings_cog.png', import.meta.url).href,
    'newWhite': new URL('./new_white.png', import.meta.url).href,
    'joinWhite': new URL('./join_white.png', import.meta.url).href,
  }
}